import { Select, Input, Modal } from '@phpcreation/frontend-components-react';
import useTranslation from '@/hooks/shared/translation/useTranslation';
import useModalsStore from '@/lib/global-stores/shared/modals/useModalsStore';
import { submitDataModifier } from '@/lib/helpers/methods';
import {
  get_all_resource,
  useCreate,
  useUpdate,
  get_single_resource,
} from '@/lib/services/api-config/crud';
import { FormInput, FormInputItem } from '@/utils/types/common';
import React, { FC, useEffect, useState } from 'react';
import parse from 'html-react-parser';

type Props = {
  resource: string;
  formInputs: FormInputItem[];
};

const ModalDuplicate: FC<Props> = ({ resource, formInputs }) => {
  const {
    isLoading: isLoadingUpdate,
    isError: isErrorUpdate,
    isSuccess: isSuccessUpdate,
    data: DataUpdate,
    mutate: duplicate_resource,
  } = useCreate(resource);

  const { modalDuplicate, setModalDuplicate } = useModalsStore();

  const [FormData, setFormData] = useState<any>({});

  useEffect(() => {
    if (modalDuplicate.data) {
      console.log(modalDuplicate.data);

      let key_value_formData = {};

      formInputs.forEach(async i => {
        console.log('->', i.name, modalDuplicate.data[i.name]);
        if (i.type == 'text') {
          //@ts-ignore
          key_value_formData[i.name] =
            //@ts-ignore
            _.get(modalDuplicate.data, i.name);
          //@ts-ignore
          console.log('with get', i, _.get(modalDuplicate.data, i.name));
        }

        if (i.type == 'select_async') {
          //@ts-ignore
          key_value_formData[i.name] = {
            label: '',
            //@ts-ignore
            value: _.get(modalDuplicate.data, i.name).id,
          }

          //@ts-ignore
          const resource = await get_single_resource(`${i.targetResourceAsync}`, _.get(modalDuplicate.data, i.name).id);

          //@ts-ignore
          key_value_formData[i.name].label = i.resourceAsyncLabelParam ? 
            parse(resource[i.resourceAsyncLabelParam]) :
            //@ts-ignore
            _.get(modalDuplicate.data, i.name).id;
        }
      });

      setFormData(key_value_formData);
    }
  }, [modalDuplicate]);

  //translate
  const { t } = useTranslation();

  return (
    <Modal
      title={
        t('Duplicate ') + t(resource.toString().slice(0, resource.length - 1))
      }
      isOpen={modalDuplicate.isOpen}
      handleClose={() => setModalDuplicate(false, null)}
      isButtonOkLoading={isLoadingUpdate}
      hanldleOK={() => {
        console.log(FormData);
        let adjusted_formData = submitDataModifier(FormData, formInputs);
        //@ts-ignore
        duplicate_resource(adjusted_formData);
      }}
      handleCancel={() => setModalDuplicate(false)}
    >
      <div className="flex flex-col items-start space-y-1">
        {formInputs.map((field: FormInputItem, index: any) => {
          if (field.type == 'text')
            return (
              <div
                key={index}
                className="flex flex-col items-start -space-y-2 text-sm"
              >
                <label>{t(field.label)}</label>

                <Input
                  // size="large"
                  onChange={e =>
                    setFormData({
                      ...FormData,
                      [field.name]: e.target.value,
                    })
                  }
                  value={FormData[field.name] ?? ''}
                  placeholder={`${t(field.placeholder ?? '')}`}
                />
              </div>
            );
          else
            return (
              <div key={index} className="flex flex-col items-start -space-y-2 text-sm">
                <label>{t(field.label)}</label>

                <Select
                  variant="async"
                  placeholder={field.placeholder}
                  defaultOptions
                  cacheOptions={true}
                  loadOptions={(input, callback) => {
                    get_all_resource(
                      `${field.targetResourceAsync}`,
                      { id: input },
                      false
                    )
                      .then(res =>
                        res.map((i: any) => {
                          return { 
                            label: field.resourceAsyncLabelParam ? parse(i[field.resourceAsyncLabelParam]) : i.id,
                            value: i.id 
                          };
                        })
                      )
                      .then(data => callback(data));
                  }}
                  onChange={(newIds: any) => {
                    console.log({ newIds });
                    setFormData({
                      ...FormData,
                      [field.name]: newIds,
                    });
                  }}
                  value={FormData[field.name]}
                />
              </div>
            );
        })}
      </div>
    </Modal>
  );
};

export default ModalDuplicate;
